import { i18n } from '@fs/zion-locale'
import { appendQueryParams, getDiscoveryOrigin } from '../../helpers/url_helper'

const discoveryOrigin = getDiscoveryOrigin()

const externalActivities = [
  {
    categoryId: 9,
    visibleId: 'my-year',
    link: `${discoveryOrigin}/discovery/myyear`,
    splash: 'external',
    inAppExternal: true,
    colorTheme: 'green',
    dataType: 'external-link',
    titleTranslationKey: 'activities.my-year',
    titleTranslationFallback: 'My Year',
    activityGroupId: 1382,
    activityGroupPoints: 0,
  },
  {
    categoryId: 9,
    visibleId: 'my-name',
    link: `${discoveryOrigin}/discovery/myname`,
    splash: 'external',
    inAppExternal: true,
    colorTheme: 'purple',
    dataType: 'external-link',
    titleTranslationKey: 'activities.my-name',
    titleTranslationFallback: 'My Name',
    activityGroupId: 1383,
    activityGroupPoints: 0,
  },
  {
    categoryId: 9,
    visibleId: 'time-machine',
    link: `${discoveryOrigin}/discovery/mytimemachine`,
    splash: 'external',
    inAppExternal: true,
    colorTheme: 'blue',
    dataType: 'external-link',
    titleTranslationKey: 'activities.time-machine',
    titleTranslationFallback: 'Time Machine',
    activityGroupId: 1384,
    activityGroupPoints: 0,
  },
  {
    categoryId: 9,
    visibleId: 'salt-lake-temple',
    link: `${discoveryOrigin}/discovery/saltlakecitytemple`,
    splash: 'external',
    inAppExternal: true,
    colorTheme: 'purple',
    dataType: 'external-link',
    titleTranslationKey: 'activities.salt-lake-temple',
    titleTranslationFallback: 'Salt Lake Temple',
    activityGroupId: 1385,
    activityGroupPoints: 0,
  },
  {
    categoryId: 9,
    visibleId: 'my-heritage',
    link: `${discoveryOrigin}/discovery/heritage`,
    splash: 'external',
    inAppExternal: true,
    colorTheme: 'yellow',
    dataType: 'external-link',
    titleTranslationKey: 'activities.my-heritage',
    titleTranslationFallback: 'My Heritage',
    activityGroupId: 1386,
    activityGroupPoints: 0,
  },
  {
    categoryId: 9,
    visibleId: 'famous-relatives-new',
    link: `${discoveryOrigin}/discovery/myfamousrelatives`,
    splash: 'external',
    inAppExternal: true,
    colorTheme: 'red',
    dataType: 'external-link',
    titleTranslationKey: 'activities.famous-relatives-new',
    titleTranslationFallback: 'Famous Relatives (New)',
    activityGroupId: 1387,
    activityGroupPoints: 0,
  },
  {
    categoryId: 9,
    visibleId: 'onboarding',
    link: `${discoveryOrigin}/discovery/onboarding?onboarding=true`,
    splash: 'external',
    inAppExternal: true,
    colorTheme: 'green',
    dataType: 'external-link',
    titleTranslationKey: 'activities.onboarding',
    titleTranslationFallback: 'Onboarding',
    activityGroupId: 1388,
    activityGroupPoints: 0,
  },
]

export const staticActivities = [
  {
    categoryId: 9,
    visibleId: 'family-avatar',
    splash: 'single',
    imageUrl: 'https://common-discovery-service-pgp.familysearchcdn.org/connect/groups/v1/games-avatar-family.png',
    imageUrlSvg: 'https://common-discovery-service-pgp.familysearchcdn.org/connect/groups/v1/games-avatar-family.svg',
    colorTheme: 'blue',
    dataType: 'family-avatar',
    disableSplashTransition: true,
    titleTranslationKey: 'activities.avatar-my-family',
    titleTranslationFallback: 'Avatar My Family',
    activityGroupId: 930,
    activityGroupPoints: 0,
  },
  {
    categoryId: 9,
    visibleId: 'all-about-me',
    link: '/discovery/about',
    splash: 'external',
    imageUrl: 'https://common-discovery-service-pgp.familysearchcdn.org/connect/activities/v1/all-about-me.png',
    imageUrlSvg: 'https://common-discovery-service-pgp.familysearchcdn.org/connect/activities/v1/all-about-me.svg',
    colorTheme: 'green',
    dataType: 'external-link',
    titleTranslationKey: 'activities.all-about-me',
    titleTranslationFallback: 'All About Me',
    activityGroupId: 1240,
    activityGroupPoints: 0,
  },
  {
    categoryId: 10,
    visibleId: 'compare-face',
    link: '/discovery/compareme',
    splash: 'external',
    imageUrl: 'https://common-discovery-service-pgp.familysearchcdn.org/connect/activities/v1/compare-a-face.png',
    imageUrlSvg: 'https://common-discovery-service-pgp.familysearchcdn.org/connect/activities/v1/compare-a-face.svg',
    colorTheme: 'yellow',
    dataType: 'external-link',
    titleTranslationKey: 'activities.compare-face',
    titleTranslationFallback: 'Compare-a-Face',
    activityGroupId: 1380,
    activityGroupPoints: 0,
  },
  {
    categoryId: 10,
    visibleId: 'famous-relatives',
    link: '/discovery/famousrelatives',
    splash: 'external',
    imageUrl: 'https://common-discovery-service-pgp.familysearchcdn.org/connect/activities/v1/famous-relatives.png',
    imageUrlSvg: 'https://common-discovery-service-pgp.familysearchcdn.org/connect/activities/v1/famous-relatives.svg',
    colorTheme: 'red',
    dataType: 'external-link',
    titleTranslationKey: 'activities.famous-relatives',
    titleTranslationFallback: 'Famous Relatives',
    activityGroupId: 1381,
    activityGroupPoints: 0,
  },
  {
    categoryId: 9,
    visibleId: 'where-am-i-from',
    link: '/discovery/explore',
    splash: 'external',
    imageUrl: 'https://common-discovery-service-pgp.familysearchcdn.org/connect/activities/v1/where-am-i-from.png',
    imageUrlSvg: 'https://common-discovery-service-pgp.familysearchcdn.org/connect/activities/v1/where-am-i-from.svg',
    colorTheme: 'blue',
    dataType: 'external-link',
    titleTranslationKey: 'activities.where-am-i-from',
    titleTranslationFallback: 'Where Am I From?',
    activityGroupId: 1250,
    activityGroupPoints: 0,
  },

  {
    categoryId: 10,
    visibleId: 'record-my-story',
    link: '/discovery/recordme/categories',
    splash: 'external',
    imageUrl: 'https://common-discovery-service-pgp.familysearchcdn.org/connect/activities/v1/record-my-story.png',
    imageUrlSvg: 'https://common-discovery-service-pgp.familysearchcdn.org/connect/activities/v1/record-my-story.svg',
    colorTheme: 'green',
    dataType: 'external-link',
    titleTranslationKey: 'activities.record-my-story',
    titleTranslationFallback: 'Record My Story',
    activityGroupId: 1379,
    activityGroupPoints: 0,
  },
  {
    categoryId: 10,
    visibleId: 'picture-my-heritage',
    link: '/discovery/picture',
    splash: 'external',
    imageUrl: 'https://common-discovery-service-pgp.familysearchcdn.org/connect/activities/v1/picture-my-heritage.png',
    imageUrlSvg:
      'https://common-discovery-service-pgp.familysearchcdn.org/connect/activities/v1/picture-my-heritage.svg',
    colorTheme: 'yellow',
    dataType: 'external-link',
    titleTranslationKey: 'activities.picture-my-heritage',
    titleTranslationFallback: 'Picture My Heritage',
    activityGroupId: 1080,
    activityGroupPoints: 0,
  },
]

export default function getStaticActivities(isPWA, includeExternalActivities) {
  const activities = includeExternalActivities ? [...staticActivities, ...externalActivities] : staticActivities
  return activities.map((activity) => {
    activity.title = i18n.t(activity.titleTranslationKey, activity.titleTranslationFallback)
    if (isPWA) {
      return {
        ...activity,
        link: activity.link ? appendQueryParams(activity.link, { hidehf: 'true' }) : activity.link,
        activityGroupId: String(activity.activityGroupId),
      }
    }
    return {
      ...activity,
      activityGroupId: String(activity.activityGroupId),
    }
  })
}
